export enum GrowthBookFeatures {
  ALL_TOURS_COMPONENT = 'all-tours-component',
  CHOOSE_FLIGHTS = 'choose-flights-to-continue',
  WHATS_INCLUDED = 'hotel-landing-whats-included',
  BEST_PRICE_GUARANTEE = 'best-price-guarantee',
  FILTERS_LEFT = 'filters-left'
}
